import {useCallback, useState} from 'react';
import {errorStatusHandle} from "../utils/error-utils";
import API from "../api";
import { useDispatch } from 'react-redux';
import { setAlertError, resetAlert } from '../store/actions';
import { isNonAscii } from "../utils/common-utils";

function useFileDownloader() {
  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();
  const downloadFileFromPath = useCallback(async (baseUrl, params=undefined) => {
    try {
      const response = await API.get(baseUrl, {
        params,
        responseType: 'blob'
      });
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;

      let fileName = 'example.xlsx';
      const disposition = response.headers['content-disposition'];
      dispatch(resetAlert());
      if (disposition) {
        const fileNameDecode = decodeURIComponent(disposition);
        if (isNonAscii(fileNameDecode)) {
          const filenameMatch = fileNameDecode.match(/filename\*?=(?:UTF-8''?)?([^;]+)/i);
          if (filenameMatch.length === 2) {
            fileName = filenameMatch[1];
          }
        } else {
          fileName = disposition.split('filename=')[1].split('"').join('');
        }
      }
      fileLink.setAttribute('download', fileName);
      document.body.appendChild(fileLink);
      fileLink.click();

      fileLink.remove();
      window.URL.revokeObjectURL(fileURL);
    } catch (e) {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        const reader =  new FileReader();
        reader.readAsText(e.response.data, 'UTF-8');
        reader.onload = () => {
          const jsonResponse = JSON.parse(reader.result);
          setErrorMessage(jsonResponse.error_message);
          dispatch(setAlertError(jsonResponse.error_message));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const downloadFile = useCallback(async (baseUrl, data) => {
    try {
      const response = await API.get(baseUrl, {
        params: data,
        responseType: 'blob',
      });

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;

      let fileName = 'example.xlsx';
      setErrorMessage('');
      const disposition = response.headers['content-disposition'];
      if (disposition) {
        const fileNameDecode = decodeURIComponent(disposition);
        if (isNonAscii(fileNameDecode)) {
          const filenameMatch = fileNameDecode.match(/filename\*?=(?:UTF-8''?)?([^;]+)/i);
          if (filenameMatch.length === 2) {
            fileName = filenameMatch[1];
          }
        } else {
          fileName = disposition.split('filename=')[1].split('"').join('');
        }
      }
      fileLink.setAttribute('download', fileName);
      document.body.appendChild(fileLink);
      fileLink.click();

      fileLink.remove();
      window.URL.revokeObjectURL(fileURL);
    } catch (e) {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        const reader =  new FileReader();
        reader.readAsText(e.response.data, 'UTF-8');
        reader.onload = () => {
          const jsonResponse = JSON.parse(reader.result);
          setErrorMessage(jsonResponse.error_message)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return {downloadFileFromPath, downloadFile, errorMessage};
}

export default useFileDownloader;
